import createEnum from 'common/utils/actionTypesHelper/createEnum';

export const notificationTypes = createEnum({
  success: null,
  error: null,
  info: null,
  warning: null,
});
